'use client';

import { Box } from '@mui/material';
import { Navbar } from './Navbar';
import { TitleMenu } from './TitleMenu';
import aboutUsHeaderIcon from '../../assets/images/svg/aboutUsHeaderIcon.svg';
import allWatchesHeaderIcon from '../../assets/images/svg/allWatchesHeaderIcon.svg';
import brandsHeaderIccon from '../../assets/images/svg/brandsHeaderIccon.svg';
import contactUsHeaderIcon from '../../assets/images/svg/contactUsHeaderIcon.svg';
import sellTradeHeaderIcon from '../../assets/images/svg/sellTradeHeaderIcon.svg';
import serviceCenterHeaderIcon from '../../assets/images/svg/serviceCenterHeaderIcon.svg';
import { useAppSelector } from 'src/hooks/reduxHooks';

const headerItems = [
  {
    title: 'About us',
    path: '/about-us',
    icon: aboutUsHeaderIcon.src,
  },
  {
    title: 'Brands',
    path: '/brands',
    icon: brandsHeaderIccon.src,
  },
  {
    title: 'All watches',
    path: '/all-watches',
    icon: allWatchesHeaderIcon.src,
  },
  {
    title: 'Sell & Trade',
    path: '/sell-trade',
    icon: sellTradeHeaderIcon.src,
  },
  {
    title: 'Service center',
    path: '/service-page',
    icon: serviceCenterHeaderIcon.src,
  },
  {
    title: 'Blog',
    path: '/blog',
    icon: allWatchesHeaderIcon.src,
  },
  {
    title: 'Contact us',
    path: '/contact-us',
    icon: contactUsHeaderIcon.src,
  },
];

export function Header() {
  const locale = useAppSelector((d) => d.locale);

  const messages = {
    header_items: headerItems.map((item, index) => ({
      ...item,
      title: locale[`header_items_${index}`],
    })),
    header_item_sell: locale['header_items_sell'],
    header_item_trade: locale['header_items_trade'],
    header_wishlist_header: locale['header_wishlist_header'],
    header_wishlist_text: locale['header_wishlist_text'],
    header_search_placeholder: locale['header_search_placeholder'],
  };

  return (
    <Box
      borderBottom='1px solid #EAEAEA'
      sx={{ backgroundColor: 'white', zIndex: 3, position: 'sticky', top: 0, minHeight: { lg: 105 } }}
    >
      <Navbar headerItems={headerItems} />
      <TitleMenu messages={messages} />
    </Box>
  );
}
